import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useGetConfig } from "../../store/use-config";
import { useOrderingStore } from "../../store/use-ordering-store";
import { defaultAgreementStates } from "../time-select-form/checkboxes-group";
import type { PhoneVerificationFormValues } from ".";
import { useValidationSchema } from "./validation-schema";

export const usePhoneVerificationForm = () => {
  const config = useGetConfig();
  const { personalDetails } = useOrderingStore();
  const agreementStates = config.agreementStates || defaultAgreementStates;
  const isCustomAgreement = !!config.customAgreement;

  const formMethods = useForm<PhoneVerificationFormValues>({
    mode: "onTouched",
    resolver: yupResolver(useValidationSchema({ agreementStates, isCustomAgreement })),
  });

  const watchIsDateOfBirth = formMethods.watch("isDateOfBirth");

  useEffect(() => {
    if (personalDetails?.dateOfBirth) {
      formMethods.setValue("isDateOfBirth", true);
    }
  }, [formMethods, personalDetails?.dateOfBirth]);

  useEffect(() => {
    if (!watchIsDateOfBirth) {
      formMethods.setValue("dateOfBirth", undefined);
    }
  }, [watchIsDateOfBirth, formMethods]);

  return {
    formMethods,
    watchIsDateOfBirth,
    agreementStates,
  };
};
